import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

function MenuDrawer({ onContact = () => { } }: { onContact?: () => void }) {
  const [isDrawerOpen, toggleDrawer] = useState(false);

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={() => toggleDrawer(false)}>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/">
            <ListItemText primary="Overview" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/products">
            <ListItemText primary="Products" />
          </ListItemButton>
        </ListItem>
        {/* Temporarily hidden until content is curated:
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/research">
            <ListItemText primary="Research" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/team">
            <ListItemText primary="Team" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/news">
            <ListItemText primary="News" />
          </ListItemButton>
        </ListItem> */}
      </List>
      <Divider/>
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={onContact}>
            <ListItemText primary="Contact" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/beta-signup">
            <ListItemText primary="Sign up for beta" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      <div onClick={() => toggleDrawer(true)} aria-label="Open menu">
        <MenuIcon/>
      </div>

      <Drawer sx={{zIndex: 10000}} anchor="right" open={isDrawerOpen} onClose={() => toggleDrawer(false)} onClick={() => toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default MenuDrawer;
